import React from 'react';
import ContactsHeader from '../components/ContactsHeader';
import ContactsTable from '../components/ContactsTable';

const Contacts: React.FC = () => {
    return (
        <div>
            <ContactsHeader />
            <ContactsTable />
        </div>
    );
};

export default Contacts;
